import { useContext, useEffect } from "react";
import ModelElements from "../ModelElements";
import { ProductModelProps } from "../ModelViewerProduct";
import ProductTextureContext from "../_contexts/ProductTextureContext";
import useGLB from "../_hooks/useGLB";

// outsideObject = 2
// insideObject = 1
// elasticObject = 3
// elasticInsideObject = 0

export default function LoungePants(props: ProductModelProps) {
    const url = new URL('@resources/3d-models/glb/lounge-pants.glb', import.meta.url);
    const model = useGLB(url)
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)

    useEffect(() => {
        if(!elements) return

        // Enable see-through for inner material
        if(elements[2]?.material) elements[2].material.side = 2
        if(elements[3]?.material) elements[3].material.side = 2
        if(elements[0]?.material) {
            elements[0].material.transparent = true
            elements[0].material.opacity = 0.98
        }
        if(elements[1]?.material) {
            elements[1].material.transparent = true
            elements[1].material.opacity = 0.8
        }
    }, [elements])

    // Apply lab texture
    useEffect(() => {
        if(!elements || !elements[0]?.material || !elements[3]?.material) return

        elements[2].material.map = productTexture
        elements[2].material.map.flipY = false
        elements[2].material.map.needsUpdate = true
        elements[3].material.map = productTexture
        elements[3].material.map.flipY = false
        elements[3].material.map.needsUpdate = true
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene}/>
}